// Client mirror of the server's shop scoping, for filtering the shop dropdowns.
// The SERVER is the security boundary; this just avoids showing options the user
// can't use.

export function getClientShopScope(user) {
  if (!user) return { all: false, ids: [] };
  let perms = user?.role?.permissions || [];
  if (typeof perms === "string") { try { perms = JSON.parse(perms); } catch { perms = []; } }
  const isAdmin = typeof user?.role?.name === "string" && user.role.name.toLowerCase().includes("admin");
  const all = isAdmin || (Array.isArray(perms) && perms.includes("ViewAllProducts"));

  const ids = new Set();
  if (user?.shop_id) ids.add(Number(user.shop_id));
  (Array.isArray(user?.allowed_shops) ? user.allowed_shops : []).forEach((id) => id && ids.add(Number(id)));
  (Array.isArray(user?.shop_sell_permissions) ? user.shop_sell_permissions : []).forEach((id) => id && ids.add(Number(id)));
  return { all, ids: Array.from(ids) };
}

/**
 * The shops a user can choose in a filter, and whether to offer "All Shops".
 * @param {Array} allShops - full shops list from the API
 * @param {object} user
 * @returns {{ shops: Array, allowAll: boolean, defaultShopId: string }}
 */
export function selectableShops(allShops = [], user) {
  const scope = getClientShopScope(user);
  if (scope.all) {
    return { shops: allShops, allowAll: true, defaultShopId: "" };
  }
  const shops = allShops.filter((s) => scope.ids.includes(Number(s.id)));
  // Non-privileged users default to their primary shop and cannot pick "All".
  const defaultShopId = (user?.shop_id && String(user.shop_id)) || (shops[0] && String(shops[0].id)) || "";
  return { shops, allowAll: false, defaultShopId };
}
